import { ReactNode } from "react";
import VibratingButton from "@/components/base/button/VibratingButton";
import { cn } from "@/lib/utils";

type vibrationType =
  | "light"
  | "medium"
  | "heavy"
  | "rigid"
  | "soft"
  | "selection"
  | "success"
  | "warning";

interface TaskBaseButtonProps {
  className?: string;
  children?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  vibrate?: boolean;
  vibrationType?: vibrationType;
  [key: string]: any;
}
const TaskBaseButton = ({
  className,
  children,
  onClick,
  disabled = false,
  vibrate = true,
  vibrationType = "soft",
}: TaskBaseButtonProps) => {
  return (
    <VibratingButton
      className={cn(
        "flex-center disabled:bg-white/08 disabled:text-gray-1 disabled:pointer-events-none pr-2 pl-2.5 leading-120 text-xs font-semibold rounded-full h-7 click-button",
        className
      )}
      onClick={onClick}
      disabled={disabled}
      vibrationType={vibrate ? vibrationType : undefined}
    >
      {children || vibrationType}
    </VibratingButton>
  );
};

export default TaskBaseButton;
